import React, { useEffect, useState } from "react";
import Reactportal from "../../../Reactportal/Reactportal";
import AddMeterialTable from "../InvoiceAndItemTable/InvoiceAndItemTable";
import Button from "../../../Button/Button";
import PortalFooter from "../../../Reactportal/PortalFooter";
import AddMeterialSection from "../AddInvoice/AddInvoice";
import AddItems from "../AddItems/AddItems";
import "../AddInvoice/AddInvoice.scss";
import { useLazyQuery } from "@apollo/client";
import { GetEwbDetailsByewbNo } from "../../../../../Utils/AllPagesQuriesAndMutations";
import Spinner from "../../../Spinner/Spinner";
import { ErrorToast } from "../../../ToastComponent/RectHotToast";

const AddInvoiceAndItemModal = ({ show, SetMeterial, handleAddInvoiceData, config, Data, Form_Key, handleFoucs, priceListData, TypeOfPortal }) => {
  const [openModal, setOpenModal] = useState(show);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [invoiceData, setInvoiceData] = useState(Data?.invoiceData?.length > 0 ? Data?.invoiceData : []);
  const [invoiceEditData, setInvoiceEditData] = useState<any>({});
  const [invoiceIndex, setInvoiceIndex] = useState();
  const [itemIndex, setItemIndex] = useState();
  const [ShowItemsModal, setShowItemsModal] = useState(false);
  const [Items, setItems] = useState<any[]>(Data?.itemsData?.length > 0 ? Data?.itemsData : []);
  const [itemEditData, setItemEditData] = useState<any>({});
  const [ewbNo, setEwbNo] = useState(null);

  const [getewbDetailsByNo, { loading: getewbDetailsByNoLoader }] = useLazyQuery(GetEwbDetailsByewbNo, {
    fetchPolicy: "network-only",
  });


  const handleInvoiceEditItems = (i) => {
    let editobj = invoiceData[i];
    // editobj.Invoice_Date = IsoToDateWithoutTime(editobj.Invoice_Date);
    // editobj.Eway_Bill_Date = IsoToDateWithoutTime(editobj.Eway_Bill_Date);
    // editobj.Eway_Bill_Expiry_Date = IsoToDateWithoutTime(editobj.Eway_Bill_Expiry_Date);
    setInvoiceIndex(i);
    setInvoiceEditData(editobj);
    setShowInvoiceModal(true);
  };

  const handleInvoiceDeleteItems = (index) => {
    const newMaterial = [...invoiceData];
    newMaterial.splice(index, 1);
    setInvoiceData(newMaterial);
  };

  useEffect(() => {
    const input = document.getElementById("invoiceFocus");
    if (input) {
      input.focus();
    }
  }, []);

  const handleEditItems = (i) => {
    let editobj = Items[i];
    setItemIndex(i);
    setItemEditData(editobj);
    setShowItemsModal(true);
  };

  const handleDeleteItems = (index) => {
    const newMaterial = [...Items];
    newMaterial.splice(index, 1);
    setItems(newMaterial);
  };

  const handleAddItems = () => {
    setShowItemsModal(true);
  };

  let submit = () => {
    handleAddInvoiceData(invoiceData, Items);
    Closeformfunction1();
  };

  const replaceObjectAtIndexForItems = (arr, newObj, idx) => {
    const newArr = arr?.map((item, index) => {
      if (index === idx) {
        return newObj;
      }
      return item;
    });
    setItems(newArr);
  };

  function isEwayBillPresent(dataArray, numberToCheck) {
    return dataArray.some(item => item.Eway_Bill_Number === numberToCheck);
  }

  const replaceObjectAtIndex = (arr, newObj, idx) => {
    const newArr = arr?.map((item, index) => {
      if (index === idx) {
        return newObj;
      }
      return item;
    });
    setInvoiceData(newArr);
  };

  let FetchEwbData = () => {
    const ewayBillPattern = /^\d{12}$/;
    if (!ewayBillPattern.test(ewbNo)) {
      ErrorToast("Insert Valid Ewb Number");
    } else if (isEwayBillPresent(invoiceData, ewbNo)) {
      ErrorToast("This Ewb Number Already Added");
    } else {
      getewbDetailsByNo({ variables: { eWayBillNo: ewbNo } })
        .then((res) => {
          let ewbData = res?.data?.getEwayBillDetailsByEwayBillNo;
          if (ewbData) {
            setInvoiceData((prev) => {
              return [
                ...prev,
                {
                  Invoice_Date: ewbData?.docDate ? ewbData?.docDate : "",
                  Invoice_Number: ewbData?.docNo ? String(ewbData?.docNo) : "",
                  Invoice_Value: ewbData?.totInvValue ? String(ewbData?.totInvValue) : "",
                  Eway_Bill_Number: ewbData?.ewbNo ? String(ewbData?.ewbNo) : "",
                  Eway_Bill_Date: ewbData?.ewayBillDate ? ewbData?.ewayBillDate.split(" ")[0] : "",
                  Eway_Bill_Expiry_Date: ewbData?.validUpto ? ewbData?.validUpto.split(" ")[0] : "",
                  ASN_No: "",
                  Invoice_Add: "",
                  Eway_Bill_Add: "",
                },
              ];
            });
            setEwbNo("");
          } else {
            ErrorToast("Unable To Fetch EWB Data");
          }
        })
        .catch((err) => ErrorToast("Unable To Fetch EWB Data"));

    }

  };

  const Closeformfunction1 = () => {
    handleFoucs("notefocus");
    SetMeterial(false);
    setOpenModal(false);
    // ClearSpecificForm(dispatch, Form_Key);
    // popModal(Form_Key);
  };

  return (
    <>
      {openModal ? (
        <Reactportal open={openModal} onClose={Closeformfunction1} TypeOfPortal={"Add Invoice And Items"} >
          <div className="AddMaterialModal">
            <div className="ewayBillmaindiv">
              <input
                type="number"
                className="ewayInput no-spinners"
                value={ewbNo}
                onChange={(e) => setEwbNo(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    FetchEwbData()
                  }
                }}
              />
              {getewbDetailsByNoLoader ? (
                <Button type="" text={<Spinner />} action="" disabled={true} children="" name="" />
              ) : (
                <Button
                  action={() => FetchEwbData()}
                  text={"Fetch EWB Data"}
                  name="ewaybtn"
                  type={""}
                  children={""}
                  disabled={""}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      FetchEwbData()
                    }
                  }}
                />
              )}
            </div>
            <div className="Items">
              <AddMeterialTable
                data={invoiceData}
                Form_Key={"Invoice"}
                handleDeleteMaterial={(i) => handleInvoiceDeleteItems(i)}
                handleEditMaterial={(i) => handleInvoiceEditItems(i)}
              />
            </div>
            <div className="AddItemDiv">
              <Button
                action={() => setShowInvoiceModal(true)}
                text="Add Invoice"
                name="AddItems"
                type={""}
                children={""}
                disabled={""}
                id={"invoiceFocus"}
              />
            </div>
            <div className="Items">
              <AddMeterialTable
                data={Items}
                Form_Key={"Item"}
                handleDeleteMaterial={(i) => handleDeleteItems(i)}
                handleEditMaterial={(i) => handleEditItems(i)}
              />
            </div>
            <div className="AddItemDiv">
              <Button action={handleAddItems} text="Add Items" name="AddItems" type={""} children={""} disabled={""} />
            </div>
          </div>
          <PortalFooter
            renderContent={() => <></>}
            disabled={false}
            submitform={submit}
            submitType={""}
            SaveAndClose={() => {
              submit();
            }}
            handleformclose={() => {
              Closeformfunction1();
              setOpenModal(!openModal);
            }}
          />
        </Reactportal>
      ) : (
        <div></div>
      )}

      {showInvoiceModal ? (
        <>
          {/* ADD INVOICE FROM */}
          <AddMeterialSection
            show={showInvoiceModal}
            setMyData={(singleData: any, index: any) => {
              if (invoiceEditData?.Invoice_Date) {
                replaceObjectAtIndex(invoiceData, singleData, index);
              } else {
                setInvoiceData((prev) => [...prev, singleData]);
              }
            }}
            SetMeterial={() => {
              setInvoiceEditData({});
              setShowInvoiceModal(false);
            }}
            config={config}
            TypeOfPortal={TypeOfPortal}
            Data={invoiceEditData ? invoiceEditData : {}}
            fielddata={undefined}
            index={invoiceIndex}
            Parent_Form_Key={Form_Key}
          />
        </>
      ) : null}
      {ShowItemsModal ? (
        // ADD ITEM FORM
        <AddItems
          show={ShowItemsModal}
          editData={itemEditData ? itemEditData : {}}
          itemConfig={{ AddMeterialItems: config?.AddMeterialItems }}
          setItems={(val: any, index: any) => {
            if (itemEditData?.No_Of_Boxes) {
              replaceObjectAtIndexForItems(Items, val, index);
            } else {
              setItems((prev: any) => [...prev, val]);
            }
          }}
          setShowModal={() => {
            setItemEditData({});
            setShowItemsModal(false);
          }}
          index={itemIndex}
          Parent_Form_Key={Form_Key}
          priceListData={priceListData}
          TypeOfPortal={TypeOfPortal}
        />
      ) : null}
    </>
  );
};

export default AddInvoiceAndItemModal;
